import { Injectable } from '@angular/core';

import { Mutation, gql } from 'apollo-angular';

import { MutationSaveCustomerJourneyArgs, SaveCustomerJourneyPayload } from '@hdms/shared/common-types';

export interface SaveCustomerJourneyResponse {
  saveCustomerJourney: SaveCustomerJourneyPayload;
}

@Injectable({
  providedIn: 'root'
})
export class CustomerJourneyGqlService extends Mutation<SaveCustomerJourneyResponse, MutationSaveCustomerJourneyArgs> {
  override document = gql`
    mutation SaveCustomerJourney($input: SaveCustomerJourneyInput!) {
      saveCustomerJourney(input: $input) {
        journeyId
      }
    }
  `;
}
